<template>
  <div v-if="isSearchVisible" class="relative mt-7">
    <Icon name="search" class="absolute left-5 top-3 size-6" />
    <input
      v-model="searchQuery"
      type="text"
      class="!box-border w-full rounded-full border-border-medium py-3.5 pl-12 pr-4 text-text-medium transition-colors hover:border-border-medium-hover focus:outline-none"
      :placeholder="t['w.global.product_option.search']()"
    />
  </div>
  <div class="mt-4">
    <div v-for="option of filteredOptions" :key="option.id">
      <button
        class="flex w-full cursor-pointer justify-between px-1 py-3 hover:text-text-medium focus:text-text-strong active:text-text-strong"
        @click="emit('selected-option', option)"
      >
        {{ option.groupParameter }}
        <Price v-if="option.price" :amount="option.price" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import Price from '~/components/price/Price.vue'
import * as t from '~/messages'

const props = defineProps({
  members: {
    type: Array,
    default: () => [],
  },
})

const searchQuery = ref('')
const isSearchVisible = props.members.length >= 6

const filteredOptions = computed(() => {
  if (!searchQuery.value && !isSearchVisible) {
    return props.members
  }
  const query = searchQuery.value.toLowerCase()

  return props.members.filter((option) => option.groupParameter.toLowerCase().includes(query))
})

const emit = defineEmits<{
  'selected-option': [option: unknown]
}>()
</script>
